import { roles } from '@nxsys/store/constants';
import Timesheets from '../../../modules/timesheets/listing/Timesheets';
import AddNewTimesheet from '../../../modules/timesheets/create/AddNewTimesheet';
import TimesheetDetail from '../../../modules/timesheets/detail/TimesheetDetail';
import AwaitingInvoiceGeneration from '../../../modules/timesheets/listing/AwaitingInvoiceGeneration';
import PendingApproval from '../../../modules/timesheets/listing/PendingApproval';
import GenerateDraftPayroll from '../../../modules/timesheets/listing/GenerateDraftPayroll';
import TimesheetsAgency from '../../../modules/timesheets/listing/TimesheetsAgency';
import TimesheetsEmployee from '../../../modules/timesheets/listing/TimesheetsEmployee';
import AddNewTimesheetEmployee from '../../../modules/timesheets/create/AddNewTimesheetEmployee';

export const timesheetsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/timesheets',
    element: <Timesheets />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/timesheets/add-new',
    element: <AddNewTimesheet />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/timesheets/:id',
    element: <TimesheetDetail />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/timesheets/pending',
    element: <PendingApproval />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/timesheets/generate-draft-payroll',
    element: <GenerateDraftPayroll />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/timesheets/awaiting-invoice-generation',
    element: <AwaitingInvoiceGeneration />,
  },
  {
    permittedRole: [roles.agency],
    path: '/timesheets-agency',
    element: <TimesheetsAgency />,
  },
  {
    permittedRole: [roles.agency],
    path: '/timesheets-agency/:id',
    element: <TimesheetDetail />,
  },
  {
    permittedRole: [roles.employee],
    path: '/timesheets-employee',
    element: <TimesheetsEmployee />,
  },
  {
    permittedRole: [roles.employee],
    path: '/timesheets-employee/add-new',
    element: <AddNewTimesheetEmployee />,
  },
  {
    permittedRole: [roles.employee],
    path: '/timesheets-employee/:id',
    element: <TimesheetDetail />,
  },
];
